module.exports = __webpack_public_path__ + "assets/img/for_vn.59c70714.jpg";